<template>
  <div class="container">
    <div class="audio-container">
      <audio
        class="audioplayer hidden md-image"
        ref="audio"
        controls
        autoplay
      ></audio>
    </div>

    <md-button ref="startBtn" class="md-raised" id="btn-start-recording">
      <md-icon>fiber_smart_record</md-icon>
      Audio-Aufnahme jetzt starten
    </md-button>

    <md-button
      ref="stopBtn"
      class="md-raised md-accent"
      id="btn-stop-recording"
      disabled
    >
      <md-icon>stop</md-icon>
      Aufnahme beenden
    </md-button>

    <md-button ref="startBtn" class="md-raised" id="btn-microphone">
      <md-icon>mic</md-icon>
    </md-button>

    <div v-if="fileBlob">
      <hr />
      <md-button class="md-raised md-primary" @click.prevent="getDownload()">
        <md-icon>cloud_download</md-icon>
        Aufnahme herunterladen
      </md-button>

      <md-button
        v-if="uploadTarget"
        class="md-raised md-accent"
        @click.prevent="onSave(fileBlob, 'audio')"
      >
        <md-icon>done_all</md-icon>
        Aufnahme jetzt einreichen
      </md-button>
    </div>
  </div>
</template>
<script>
import RecordRTC from "recordrtc";
import { script } from "@/components/recorder/parts/audio.js";
export default {
  components: {},
  props: {
    onSave: Function,
    fileName: String,
    uploadTarget: String
  },
  data() {
    return {
      fileBlob: false
    };
  },
  methods: {
    getDownload() {
      const url = this.fileBlob;
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = this.fileName + ".mp3";
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    },
    getRtc() {
      var s = new script();
      s.RecordRTC = RecordRTC;
      s.audio = this.$refs.audio;
      s.startBtn = document.getElementById("btn-start-recording");
      s.stopBtn = document.getElementById("btn-stop-recording");
      s.microphoneBtn = document.getElementById("btn-microphone");
      s.callback = function(data) {
        this.fileBlob = data;
      }.bind(this);
      s.listener();
    }
  },
  mounted() {
    this.getRtc();
  },
  computed: {}
};
</script>
<style lang="sass" scoped>
.container
  text-align: center
  margin: 20px 0
  box-sizing: border-box
  .md-image
    display: inline
  .md-raised:disabled
    display: none
  .audio-container
    margin: 10px 0
    audio, .audioplayer, .md-image
      margin: 10px 0
      box-sizing: border-box
      height: 60px !important
      &.hidden
        display: none
    @media (max-width: 500px)
      audio, .audioplayer
        width: 100%
</style>
